import { render, staticRenderFns } from "./DeliverOrders.vue?vue&type=template&id=1e1db841&"
import script from "./DeliverOrders.vue?vue&type=script&lang=js&"
export * from "./DeliverOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports